import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../state/demo-dux';
import seriesLoader from './seriesLoader';
import colorGradient from './gradients';

class TrendChart extends Component {
  constructor(props) {
    super(props);
  }

  highChartsRender = (
    {
      seriesInfo,
      yAxisSide,
      asPercent,
      containerName,
      hideYAxis,
      hideXAxis,
      hideLegend,
      backgroundColor,
      dataMax,
      sliceIndex,
      showDatalabel
    }
  ) => {
    
    const config = {
      chart: {
        type: 'spline',
        renderTo: containerName,
        spacingBottom: 0,
        spacingTop: 15,
        spacingLeft: 0,
        spacingRight: hideYAxis ? 5 : 20,
        marginLeft: hideYAxis ? 0 : 45,
        backgroundColor: backgroundColor || '#FFFFFF',
        events: {
          load: function() {
            if (showDatalabel) {
              const data = this.series[1].points;
              const datalabel = data[sliceIndex];
              datalabel.update({
                dataLabels: {
                  enabled: true,
                  align: 'center',
                  position: 'center',
                  useHTML: true,
                  formatter: function() {
                    return '<div class="trend-data-label" style="background-color: ' +
                      colorGradient(this.y / 100) +
                      '">' +
                      this.y +
                      '</div>';
                  }
                }
              });
            }
          }
        }
      },
      title: {
        style: { display: 'none' }
      },
      yAxis: {
        height: '107%',
        endOnTick: false,
        opposite: yAxisSide,
        visible: !hideYAxis,
        title: {
          enabled: false
        },
        max: 110,
        min: 0,
        lineColor: '#DDDDDD',
        lineWidth: 1,
        gridLineColor: 'transparent',
        labels: {
          formatter: function() {
            return asPercent
              ? this.axis.defaultLabelFormatter.call(this) + '%'
              : '$' + this.axis.defaultLabelFormatter.call(this);
          }
        }
      },
      xAxis: {
        offset: 10,
        type: 'datetime',
        visible: !hideXAxis,
        tickLength: 0,
        dateTimeLabelFormats: {
          second: '%H:%M:%S',
          minute: '%H:%M',
          hour: '%H:%M',
          day: '%e. %b',
          week: '%e. %b',
          month: '%b', //month formatted as month only
          year: '%Y'
        }
      },
      legend: {
        enabled: !hideLegend
      },
      tooltip: {
        enabled: false
      },
      plotOptions: {
        series: {
          enableMouseTracking: false,
          states: {
            inactive: {
              opacity: 1
            }
          },
          events: {
            legendItemClick: function() {
              return false;
            }
          }
        }
      },
      series: (seriesInfo || []).map(series => series)
    };
    return config;
  };

  render() {
    const {
      projectData,
      asPercent,
      containerName,
      hideYAxis,
      hideXAxis,
      hideLegend,
      hideActual,
      hideForecast,
      knowledgeArea,
      isGradient,
      yAxisSide,
      backgroundColor,
      width,
      height,
      activeSliceIndex,
      hideMarkers,
      theme,
      showDatalabel,
      isTier2
    } = this.props || {};

    const {
      totalBudget
    } = projectData || {};

    const seriesActual = seriesLoader({
      projectData,
      knowledgeArea,
      valueType: 'valueActual',
      name: 'Actual',
      lineStyle: 'Solid',
      hideMarkers: hideMarkers,
      asPercent,
      maxPercentValue: totalBudget,
      hide: hideActual,
      isGradient,
      isTrend: true,
      showLastPoint: activeSliceIndex,
      marker: {
        symbol: 'circle',
        fillColor: theme === 'dark' ? '#FFFFFF' : 'red',
        lineWidth: 2,
        lineColor: theme === 'dark' ? '#0D0E3F' : '#FFFFFF'
      },
      isTier2
    }); //mainly for cost values

    const seriesForecast = seriesLoader({
      projectData,
      knowledgeArea,
      valueType: 'valueForecast',
      name: 'Forecast',
      lineStyle: 'Shortdash',
      hideMarkers: hideMarkers,
      asPercent,
      maxPercentValue: totalBudget,
      hide: hideForecast,
      isGradient,
      isTrend: true,
      showLastPoint: activeSliceIndex,
      marker: {
        symbol: 'circle',
        fillColor: theme === 'dark' ? '#FFFFFF' : 'red',
        lineWidth: 2,
        lineColor: theme === 'dark' ? '#0D0E3F' : '#FFFFFF'
      },
      isTier2
    }); //mainly for cost values

    const finalMax = asPercent && knowledgeArea === 'cost' ? 115 : 105;

    const sliceIndex = activeSliceIndex
      ? activeSliceIndex
      : isTier2 ? projectData.endSliceIndex : projectData.nowSliceIndexTier1;

    const chart = this.highChartsRender({
      seriesInfo: [seriesForecast, seriesActual],
      yAxisSide: yAxisSide,
      dataMax: finalMax,
      asPercent,
      containerName,
      hideYAxis,
      hideXAxis,
      hideLegend,
      backgroundColor,
      sliceIndex,
      showDatalabel
    });

    return (
      <div id={containerName} style={{ height, width }}>
        <HighchartsReact
          highcharts={Highcharts}
          options={chart}
          containerProps={{ style: { width: '100%', height: '100%' } }}
        />
      </div>
    );
  }
}

const mapState = state => ({
  projects: state.demo.toJS().projects
});
const mapDispatch = dispatch => bindActionCreators(actionCreators, dispatch);
export default connect(mapState, mapDispatch)(TrendChart);
